module.exports = __webpack_public_path__ + "static/wallet-af916d9b2cc26d720393c9e2f242074d.png";